import { render, staticRenderFns } from "./vipDetailAddress.vue?vue&type=template&id=2cd2e871&scoped=true"
import script from "./vipDetailAddress.vue?vue&type=script&lang=js"
export * from "./vipDetailAddress.vue?vue&type=script&lang=js"
import style0 from "./vipDetailAddress.vue?vue&type=style&index=0&id=2cd2e871&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd2e871",
  null
  
)

export default component.exports